function withVideoPosterHash(url) {
  if (!url) return '';
  if (url.indexOf('#') >= 0) return url;
  return url + '#t=0.1';
}

function applyGroupCollapse(group, itemSelector) {
  if (!group) return;
  const limit = parseInt(group.getAttribute('data-collapse-count') || '10', 10);
  const items = group.querySelectorAll(itemSelector);
  const toggleWrap = group.querySelector('.group-tab-toggle-wrap');
  if (!items.length) return;

  items.forEach((item, i) => {
    item.classList.toggle('is-extra', i >= limit);
  });

  if (items.length > limit) {
    group.setAttribute('data-collapsed', 'true');
    if (toggleWrap) toggleWrap.hidden = false;
  } else {
    group.removeAttribute('data-collapsed');
    if (toggleWrap) toggleWrap.hidden = true;
  }
}

function initGroupTabToggles() {
  document.querySelectorAll('.page-product .group-tab-toggle').forEach((btn, index) => {
    if (btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';
    btn.setAttribute('aria-expanded', btn.getAttribute('data-expanded') === 'true' ? 'true' : 'false');
    const toggleWrap = btn.closest('.group-tab-toggle-wrap');
    const controlledContent = toggleWrap && toggleWrap.previousElementSibling;
    if (controlledContent) {
      if (!controlledContent.id) controlledContent.id = `ProductSupportExpandable-${index}`;
      btn.setAttribute('aria-controls', controlledContent.id);
    }
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-collapse-count]') || btn.closest('.group-tab-item');
      if (!group) return;
      const expanded = btn.getAttribute('data-expanded') === 'true';
      const next = !expanded;
      btn.setAttribute('data-expanded', next ? 'true' : 'false');
      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      if (next) {
        group.removeAttribute('data-collapsed');
      } else {
        group.setAttribute('data-collapsed', 'true');
      }
      const more = btn.querySelector('[data-label-more]');
      const less = btn.querySelector('[data-label-less]');
      if (more) more.hidden = next;
      if (less) less.hidden = !next;
    });
  });
}

function renderFaq(data) {
  let template = document.querySelector('#faq-template').innerHTML;

  let html = []
  data.forEach(item => {
    let temp = template;
    html.push(temp.replace(/{title}/, item.title).replace(/{content}/, item.content));
  })
  document.querySelector('.page-product .faq-content').innerHTML = html.join('');
  applyGroupCollapse(document.querySelector('.page-product .group-faq'), '.faq-wrapper');
}

function handleFaqEvent() {
  const faq_wrapper = document.querySelectorAll('.page-product .faq-wrapper');

  faq_wrapper.forEach((item, key) => {
    const button = item.querySelector('.faq-title-outer');
    const panel = item.querySelector('.faq-conten-outer');
    if (!button || !panel) return;

    const panelId = `ProductFaqPanel-${key}`;
    panel.id = panelId;
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-expanded', 'false');
    panel.hidden = true;

    button.addEventListener('click', () => {
      const willExpand = button.getAttribute('aria-expanded') !== 'true';

      faq_wrapper.forEach((el, i) => {
        if (i!== key) {
          el.classList.remove('faq-wrapper-active');
          const otherButton = el.querySelector('.faq-title-outer');
          const otherPanel = el.querySelector('.faq-conten-outer');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        }
      });

      item.classList.toggle('faq-wrapper-active', willExpand);
      button.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
      panel.hidden = !willExpand;
    });
  });
}

function myFaq() {
  const faqEl = document.querySelector('.page-product .faq-box');
  const faqId = faqEl?.getAttribute('data-id');
  const loadingEl = document.querySelector('.page-product .faq-box .loading');
  const noFaqEl = document.querySelector('.page-product .faq-box .no-data');

  if (faqId) {
    fetch(
      '/apps/api/product/faq?product_name=' +
        faqId +
        '&lang=' +
        window.theme.lang +
        '&shop=' +
        encodeURIComponent(window.location.hostname)
    )
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
      })
      .then((response) => {
        loadingEl.classList.add('hidden');
        if (response && response.code == 200) {
          if (response.data.data.length === 0) {
            noFaqEl.classList.remove('hidden');
          } else {
            renderFaq(response.data.data);
            handleFaqEvent();
          }
        } else {
          noFaqEl.classList.remove('hidden');
        }
      });
  }

  // todo: view productId
  const productId = document.querySelector('.product-info-wrapper').getAttribute('data-product-id')
  const lang = document.querySelector('html').getAttribute('lang')
  fetch('/apps/api/product/view/save', {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      products: [productId],
      locale: lang
    })
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
    })
    .then((response) => {});
}

function productPage() {
  const el = document.querySelectorAll('.page-product .section-help-item');
  const elTabContent = document.querySelectorAll('.page-product .group-tab-item');
  const typeArr = Array.from(el).map(item => item.getAttribute('data-type'));

  // 初始化 tabs 的选中状态及对应 panel。
  const initialActiveIdx = Array.from(el).findIndex((t) => t.classList.contains('active'));
  el.forEach((tab, index) => {
    const active = index === initialActiveIdx;
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.tabIndex = active ? 0 : -1;
    if (elTabContent[index]) {
      elTabContent[index].classList.toggle('hidden', !active);
      elTabContent[index].hidden = !active;
    }
  });

  el.forEach((item, index) => {
    item.onclick = () => {
      const videoEls = document.querySelectorAll('.page-product .video');
      if (videoEls.length > 0) {
        videoEls.forEach(videoEl => {
          if (videoEl.tagName === 'VIDEO' && videoEl.getAttribute('src')) {
            videoEl.pause();
          } else if (videoEl.tagName === 'IFRAME' && videoEl.classList.contains('video--youtube')) {
            videoEl.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }

      if (!item.classList.contains('active')) {
        el.forEach((i) => {
          i.classList.remove('active');
          i.setAttribute('aria-selected', 'false');
          i.tabIndex = -1;
        })

        item.classList.add('active');
        item.setAttribute('aria-selected', 'true');
        item.tabIndex = 0;
        elTabContent.forEach((m, i) => {
          m.classList.add('hidden');
          m.hidden = true;
          if (i == index) {
            m.classList.remove('hidden');
            m.hidden = false;
            window.location.hash = typeArr[i]
            
            if (m.querySelectorAll('.video').length > 0) {
              m.querySelectorAll('.video').forEach(videoEl => {
                if (videoEl.tagName === 'VIDEO' && !videoEl.getAttribute('src')) {
                  videoEl.setAttribute('src', withVideoPosterHash(videoEl.getAttribute('data-video')));
                }
              });
            }
          }
        })
      }
    }

    item.addEventListener('keydown', (event) => {
      let nextIndex;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % el.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + el.length) % el.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = el.length - 1;
      if (nextIndex === undefined) return;
      event.preventDefault();
      el[nextIndex].click();
      el[nextIndex].focus();
    });
  })
  const hash = window.location.hash.split('#');
  if (hash.length > 1) {
    typeArr.forEach(function(item, i) {
      if (hash[1].includes(item)) {
        el[i].click();
      }
    })
  }

  if (document.querySelector('.page-product')) {
    myFaq()
    initForumTagsTab();
    initHelpCenterSelectNav();
    document.querySelectorAll('.page-product .group-user-manual').forEach((group) => {
      applyGroupCollapse(group, '.manual-item');
    });
    document.querySelectorAll('.page-product .video-category').forEach((group) => {
      applyGroupCollapse(group, '.video-item');
    });
    initVideoSubTabs();
    initGroupTabToggles();
    preloadProductVideos();
  }
}

function initHelpCenterSelectNav() {
  const nav = document.querySelector('.page-product [data-help-center-nav]');
  const track = nav && nav.querySelector('[data-help-center-track]');
  const prevButton = nav && nav.querySelector('[data-help-center-prev]');
  const nextButton = nav && nav.querySelector('[data-help-center-next]');
  const buttons = track ? Array.from(track.querySelectorAll('.section-help-item')) : [];

  if (!nav || !track || !buttons.length || nav.dataset.initialized === 'true') return;
  nav.dataset.initialized = 'true';

  const updateScrollNavVisibility = () => {
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    const hasOverflow = maxScrollLeft > 1;
    if (prevButton) {
      prevButton.classList.toggle('isShow', hasOverflow && track.scrollLeft > 1);
    }
    if (nextButton) {
      nextButton.classList.toggle('isShow', hasOverflow && track.scrollLeft < maxScrollLeft - 1);
    }
  };

  const scrollStep = () => {
    const firstButton = buttons[0];
    const buttonWidth = firstButton ? firstButton.offsetWidth : 120;
    const gap = 20;
    return buttonWidth + gap;
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      window.requestAnimationFrame(() => {
        button.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      });
    });
  });

  if (track) {
    track.addEventListener('scroll', updateScrollNavVisibility, { passive: true });
    window.addEventListener('resize', updateScrollNavVisibility);
    updateScrollNavVisibility();
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
  }

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });
  }
}

function preloadProductVideos() {
  const videos = document.querySelectorAll('.page-product .group-install-video video');
  if (!videos.length) return;
  const trigger = function () {
    videos.forEach((v) => {
      if (v.getAttribute('src') && v.readyState === 0) {
        try { v.load(); } catch (e) {}
      }
    });
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(trigger, { timeout: 2000 });
  } else {
    setTimeout(trigger, 200);
  }
}

function initVideoSubTabs() {
  const panel = document.querySelector('.page-product .group-install-video');
  if (!panel) return;
  const tabs = panel.querySelectorAll('.video-subtab');
  const wraps = panel.querySelectorAll('[data-category-wrap]');
  const activateTab = (tab) => {
      const target = tab.getAttribute('data-video-category');
      tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });
      wraps.forEach((w) => {
        const match = w.getAttribute('data-category-wrap') === target;
        w.hidden = !match;
        if (!match) {
          w.querySelectorAll('video').forEach((v) => {
            if (v.getAttribute('src')) v.pause();
          });
        } else {
          w.querySelectorAll('video').forEach((v) => {
            if (!v.getAttribute('src')) v.setAttribute('src', withVideoPosterHash(v.getAttribute('data-video')));
          });
        }
      });
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      activateTab(tab);
    });
    tab.addEventListener('keydown', (event) => {
      let nextIndex;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === undefined) return;
      event.preventDefault();
      activateTab(tabs[nextIndex]);
      tabs[nextIndex].focus();
    });
  });
}

productPage();

function initForumTagsTab() {
  const forumContainer = document.querySelector('.page-product .group-forum-tags');
  const forumButton = document.querySelector('.page-product .section-help-item[data-type="forum-tags"]');
  if (!forumContainer || !forumButton) return;

  const forumContent = forumContainer.querySelector('.forum-tags-content');
  const loadingEl = forumContainer.querySelector('.loading');
  const noDataEl = forumContainer.querySelector('.no-data');
  const tags = forumContainer.getAttribute('data-tags');
  const lang = document.documentElement.getAttribute('lang') || 'en';
  const shop = window.location && window.location.hostname ? window.location.hostname : '';

  const loadForumPosts = () => {
    if (!tags || forumContainer.dataset.loaded === 'true') return;
    if (loadingEl) loadingEl.classList.remove('hidden');
    if (noDataEl) noDataEl.classList.add('hidden');
    let tagList = [];
    if (tags && typeof tags === 'string') {
      tagList = JSON.parse(tags).map(function(t) { return t.trim(); });
    } else {
      tagList = tags;
    }
    if (!Array.isArray(tagList)) {
      return;
    }
    const renderResult = function(res) {
      if (loadingEl) loadingEl.classList.add('hidden');
      if (res && res.code === 200 && Array.isArray(res.data) && res.data.length > 0) {
        const tmpl = document.querySelector('#forum-item-template');
        const tmplHtml = tmpl ? tmpl.innerHTML : '';
        forumContent.innerHTML = res.data
          .map(
            function(post) {
              var rawDate = post.created_at || post.posted_at || post.last_posted_at || post.date || '';
              var date = '';
              if (rawDate) {
                var dt = new Date(rawDate);
                if (!isNaN(dt.getTime())) {
                  var y = dt.getFullYear();
                  var m = String(dt.getMonth() + 1).padStart(2, '0');
                  var d = String(dt.getDate()).padStart(2, '0');
                  date = y + '-' + m + '-' + d;
                } else {
                  date = String(rawDate);
                }
              }
              var views = post.views != null ? post.views : (post.view_count != null ? post.view_count : 0);
              var comments = post.posts_count != null ? post.posts_count : (post.reply_count != null ? post.reply_count : (post.comment_count != null ? post.comment_count : (post.replies_count != null ? post.replies_count : 0)));
              var hotClass = (post.is_hot || post.hot) ? ' forum-post-item--hot' : '';
              var featuredClass = (post.is_featured || post.featured) ? ' forum-post-item--featured' : '';
              if (tmplHtml) {
                return tmplHtml
                  .replace(/\{topic_url\}/g, post.topic_url || '')
                  .replace(/\{title\}/g, post.title || '')
                  .replace(/\{excerpt\}/g, post.excerpt || '')
                  .replace(/\{date\}/g, date)
                  .replace(/\{views\}/g, views)
                  .replace(/\{comments\}/g, comments)
                  .replace(/\{hot_class\}/g, hotClass)
                  .replace(/\{featured_class\}/g, featuredClass);
              }
              return '';
            }
          )
          .join('');

        applyGroupCollapse(forumContainer, '.forum-post-item');
        initGroupTabToggles();

        forumContainer.dataset.loaded = 'true';
      } else if (noDataEl) {
        noDataEl.classList.remove('hidden');
      }
    };

    const params = { page: 1, per_page: 99,  shop: shop, tagList: tagList , lang: lang };
    fetch('/apps/api/product/forumTopic', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    })
      .then(function(res) { return res && res.ok ? res.json() : null; })
      .then(function(res) {
        renderResult(res);
      })
      .catch(function() {
        if (loadingEl) loadingEl.classList.add('hidden');
      });
  };
  loadForumPosts();
}

const pageTypeMap = [{
  id: 1,
  type: 'faq'
}, {
  id: 2,
  type: 'manual'
}, {
  id: 3,
  type: 'video'
}]
function plpTabClick() {
  const wrappers = document.querySelectorAll('.help-center-wrapper');
  wrappers.forEach((wrapper) => {
    const elem = wrapper.querySelectorAll('.content-tab');
    const tabContents = wrapper.querySelectorAll('.tab-item');
    const recommendTabContent = wrapper.querySelector('.tab-content-0');

    const hidePanel = (panel) => {
      panel.classList.add('hidden');
      panel.hidden = true;
    };

    const showPanel = (panel) => {
      panel.classList.remove('hidden');
      panel.hidden = false;
    };

    elem.forEach((el) => {
      el.onclick = () => {
        if (el.classList.contains('active') && recommendTabContent) {
          el.classList.remove('active');
          el.setAttribute('aria-pressed', 'false');
          tabContents.forEach(hidePanel);
          showPanel(recommendTabContent);
        } else {
          elem.forEach((e) => {
            e.classList.remove('active');
            e.setAttribute('aria-pressed', 'false');
          });
          el.classList.add('active');
          el.setAttribute('aria-pressed', 'true');

          // show tabs
          const panelId = el.getAttribute('aria-controls');
          const curTabContent = panelId ? document.getElementById(panelId) : null;
          if (curTabContent) {
            tabContents.forEach(hidePanel);
            showPanel(curTabContent);
          }
        }
      };
    });
  });
}

function plpChangeType() {
  const elem = document.querySelectorAll('.section-help-center .section-help-item');
  const url = new URL(location);
  elem.forEach((el, i) => {
    el.onclick = () => {
      elem.forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-pressed', 'false');
      })
      el.classList.add('active');
      el.setAttribute('aria-pressed', 'true');
      const curTab = pageTypeMap.find((item) => {
        return item.id  === i + 1;
      });

      if (curTab) {
        document.querySelector('.help-center-wrapper').setAttribute('data-type', curTab.type);
        url.searchParams.set("type", curTab.type);
        history.pushState({}, "", url);
      }
    }
  })
}

function plpDownload() {
  document.querySelectorAll('.btn.btn-download').forEach(function(elem) {
    elem.onclick = function(e) {
      // 防止递归死循环
      if (elem.dataset.downloaded === 'true') {
        elem.dataset.downloaded = '';
        return;
      }
      let pdfUrl = elem.getAttribute('data-href');
      let url = elem.getAttribute('href');
      if (pdfUrl && (!url || url === pdfUrl)) {
        e.preventDefault();
        elem.classList.add('disabled');
        let controller = null;
        let timeoutId = null;

        if ('AbortController' in window) {
          controller = new AbortController();
          timeoutId = setTimeout(function() {
            controller.abort();
          }, 15000); // 15 秒超时
        }

        fetch(pdfUrl, {
          method: 'get',
          signal: controller ? controller.signal : undefined
        })
          .then(function(res) {
            if (timeoutId) clearTimeout(timeoutId);
            if (!res || !res.ok) {
              throw new Error('Download failed');
            }
            return res.blob();
          })
          .then(function(blob) {
            const blobUrl = URL.createObjectURL(blob);
            elem.setAttribute('href', blobUrl);
            elem.dataset.downloaded = 'true';
            elem.click();
          })
          .catch(function() {
            // fetch 超时或失败时，创建一个临时 a[download] 触发下载
            var link = document.createElement('a');
            link.href = pdfUrl;
            link.download = '';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .finally(function() {
            if (timeoutId) clearTimeout(timeoutId);
            elem.classList.remove('disabled');
          });
      }
    }
  })
}

function plpInit() {
  let a = new URLSearchParams(window.location.search);
  let pageType = a.get('type');
  let pageId = a.get('id');


  const curTab = pageTypeMap.find((item) => {
    return item.type === pageType;
  });

  if (curTab) {
    document.querySelectorAll('.section-help-center .section-help-item').forEach((item, i) => {
      if (i + 1 ==  curTab.id) {
        item.classList.add('active');
        item.setAttribute('aria-pressed', 'true');
        document.querySelector('.help-center-wrapper').setAttribute('data-type', curTab.type);
      } else {
        item.setAttribute('aria-pressed', 'false');
        if (item.classList.contains('active')) {
          item.classList.remove('active');
        }
      }
    })
  }

  if (pageId) {
    const curNav = document.querySelector('[data-id="'+ pageId +'"]');

    if (curNav) {
      curNav.click();
    }
  } else {
    const plpPage = document.querySelector('.help-center-wrapper');
    const targetEl = document.querySelector('.recommend_systerm .product-grid');
    if (!plpPage || !targetEl) {
      return
    }

    getRecommendProduct(targetEl)
  }
}

function getRecommendProduct(targetEl) {
  fetch('/apps/api/product/view/recommand')
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
    })
    .then((response) => {
      if (response && response.code == 200) {
        document.querySelector('.content-items .loading').addClass('hidden');
        if (response.data.length === 0) {
          
        } else {
          const temp = document.querySelector('#product-template').innerHTML;
          const html = []
          const data = response.data
  
          // new Array(1).fill({
          //   product_img: '//aqara-support.myshopify.com/cdn/shop/files/3_f7aa1a26-aad2-481b-96fa-af58be59b2b0.png?v=1720419213&width=533',
          //   product_title: 'Aqara 2K Indoor Security Camera E1',
          //   handle: 'aqara-video-doorbell-g4',
          //   product_model: 'lumi.camera.acn006',
          //   product_pdf: 'https://www.aqara.com/wp-content/uploads/2023/11/Camera-E1_User-Manual.pdf',
          //   product_video: 'https://cdn.shopify.com/videos/c/o/v/00e64f200bed4ff5900b69c10022b600.mp4',
          //   width: '1200',
          //   height: '1200',
          //   product_id: '8641247379670'
          // })
          data.forEach(function(item) {
            let template = temp
            let product_img = item.images && item.images.nodes && item.images.nodes.length > 0 ? item.images.nodes[0].src + '&width=533' : ''
            html.push(template
              .replace(/{product_img}/, product_img)
              .replace(/{featured_media_width}/, 1200)
              .replace(/{featured_media_height}/, 1200)
              .replace(/{featured_media_alt}/, '')
              .replace(/{product_url}/g, '/products' + item.url)
              .replace(/{product_id}/g, item.rid)
              .replace(/{product_title}/g, item.title)
              .replace(/{product_pdf}/g, item.product_pdf || '')
              .replace(/{product_video}/, item.product_video)
              .replace(/{product_model}/, item.model_name)
            )
          })
          targetEl.innerHTML = html.join()
          targetEl.querySelectorAll('.card-btns').forEach((actions) => {
            const preview = actions.querySelector('.btn-preview');
            const download = actions.querySelector('.btn-download');
            if (preview?.getAttribute('href') || download?.getAttribute('data-href')) return;
            [preview, download].forEach((link) => {
              if (!link) return;
              const button = document.createElement('button');
              button.type = 'button';
              button.className = link.className;
              button.disabled = true;
              button.textContent = link.textContent.trim();
              link.replaceWith(button);
            });
          });
        }
      } else {
        document.querySelector('.content-items .loading').addClass('hidden');
      }
    });
}

function plpPage() {
  plpTabClick();
  plpChangeType();
  plpDownload();
  plpInit();
}

function initCollectionMegaMenu() {
  document.querySelectorAll('.mega-menu--collections-hover').forEach((menu) => {
    const trigger = menu.querySelector('.mega-menu__collections-trigger');
    if (!trigger) return;

    const openMenu = () => {
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('focus', openMenu);
    trigger.addEventListener('click', openMenu);

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', () => {
      if (!menu.contains(document.activeElement)) closeMenu();
    });
    menu.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!menu.contains(document.activeElement)) closeMenu();
      });
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeMenu();
      trigger.focus();
    });
  });
}

initCollectionMegaMenu();
plpPage();

async function embedChatbot() {
  if (window.theme.liveChat.live_chat_enable == 'false') {
    return;
  }
  const locale = (window.theme.lang || 'en').toLowerCase();
  const chatLang = locale.startsWith('de')
    ? 'de'
    : locale.startsWith('ja')
      ? 'ja'
      : locale.startsWith('ko')
        ? 'ko'
        : locale.startsWith('zh')
          ? 'zh-CN'
          : 'en';
  const token = String(window.theme.liveChat.tokens[chatLang] || '').trim();

  if (!token) {
    console.warn(`Live chat token is not configured for the ${chatLang} site.`);
    return;
  }

  const env = String(window.theme.liveChat.env || 'cn').trim();
  const chatUrl = `https://agenthub.aqara.com/chatbot?token=${encodeURIComponent(token)}&env=${encodeURIComponent(env)}&lang=${encodeURIComponent(chatLang)}`;
  const viewportWidth = document.documentElement.clientWidth || document.body.clientWidth;
  const viewportHeight = document.documentElement.clientHeight || document.body.clientHeight;
  const chatWidth = viewportHeight < viewportWidth ? '40vw' : '70vw';
  const heightOffset = viewportHeight < viewportWidth ? '40px' : '20%';
  const minWidth = Math.min(viewportWidth - 100, 300) + 'px';
  const openIcon = `<svg
            id="openIcon"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.7586 2L16.2412 2C17.0462 1.99999 17.7105 1.99998 18.2517 2.04419C18.8138 2.09012 19.3305 2.18868 19.8159 2.43598C20.5685 2.81947 21.1804 3.43139 21.5639 4.18404C21.8112 4.66937 21.9098 5.18608 21.9557 5.74818C21.9999 6.28937 21.9999 6.95373 21.9999 7.7587L22 14.1376C22.0004 14.933 22.0007 15.5236 21.8636 16.0353C21.4937 17.4156 20.4155 18.4938 19.0352 18.8637C18.7277 18.9461 18.3917 18.9789 17.9999 18.9918L17.9999 20.371C18 20.6062 18 20.846 17.9822 21.0425C17.9651 21.2305 17.9199 21.5852 17.6722 21.8955C17.3872 22.2525 16.9551 22.4602 16.4983 22.4597C16.1013 22.4593 15.7961 22.273 15.6386 22.1689C15.474 22.06 15.2868 21.9102 15.1031 21.7632L12.69 19.8327C12.1714 19.4178 12.0174 19.3007 11.8575 19.219C11.697 19.137 11.5262 19.0771 11.3496 19.0408C11.1737 19.0047 10.9803 19 10.3162 19H7.75858C6.95362 19 6.28927 19 5.74808 18.9558C5.18598 18.9099 4.66928 18.8113 4.18394 18.564C3.43129 18.1805 2.81937 17.5686 2.43588 16.816C2.18859 16.3306 2.09002 15.8139 2.0441 15.2518C1.99988 14.7106 1.99989 14.0463 1.9999 13.2413V7.75868C1.99989 6.95372 1.99988 6.28936 2.0441 5.74818C2.09002 5.18608 2.18859 4.66937 2.43588 4.18404C2.81937 3.43139 3.43129 2.81947 4.18394 2.43598C4.66928 2.18868 5.18598 2.09012 5.74808 2.04419C6.28927 1.99998 6.95364 1.99999 7.7586 2ZM10.5073 7.5C10.5073 6.67157 9.83575 6 9.00732 6C8.1789 6 7.50732 6.67157 7.50732 7.5C7.50732 8.32843 8.1789 9 9.00732 9C9.83575 9 10.5073 8.32843 10.5073 7.5ZM16.6073 11.7001C16.1669 11.3697 15.5426 11.4577 15.2105 11.8959C15.1488 11.9746 15.081 12.0486 15.0119 12.1207C14.8646 12.2744 14.6432 12.4829 14.3566 12.6913C13.7796 13.111 12.9818 13.5001 12.0073 13.5001C11.0328 13.5001 10.235 13.111 9.65799 12.6913C9.37138 12.4829 9.15004 12.2744 9.00274 12.1207C8.93366 12.0486 8.86581 11.9745 8.80418 11.8959C8.472 11.4577 7.84775 11.3697 7.40732 11.7001C6.96549 12.0314 6.87595 12.6582 7.20732 13.1001C7.20479 13.0968 7.21072 13.1043 7.22094 13.1171C7.24532 13.1478 7.29407 13.2091 7.31068 13.2289C7.36932 13.2987 7.45232 13.3934 7.55877 13.5045C7.77084 13.7258 8.08075 14.0172 8.48165 14.3088C9.27958 14.8891 10.4818 15.5001 12.0073 15.5001C13.5328 15.5001 14.735 14.8891 15.533 14.3088C15.9339 14.0172 16.2438 13.7258 16.4559 13.5045C16.5623 13.3934 16.6453 13.2987 16.704 13.2289C16.7333 13.1939 16.7567 13.165 16.7739 13.1432C17.1193 12.6969 17.0729 12.0493 16.6073 11.7001ZM15.0073 6C15.8358 6 16.5073 6.67157 16.5073 7.5C16.5073 8.32843 15.8358 9 15.0073 9C14.1789 9 13.5073 8.32843 13.5073 7.5C13.5073 6.67157 14.1789 6 15.0073 6Z"
              fill="#121212"
            />
          </svg>`;
  const closeIcon = `<svg
          id="closeIcon"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 18L6 6M6 18L18 6"
            stroke="#121212"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>`;
  if (!document.getElementById('dify-chatbot-bubble-button')) {
    const button = document.createElement('button');
    button.id = 'dify-chatbot-bubble-button';
    button.type = 'button';
    button.tabIndex = 0;
    button.setAttribute('aria-label', window.theme.liveChat.open_label || 'Open live chat');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'dify-chatbot-bubble-window');
    button.setAttribute('aria-haspopup', 'dialog');
    button.style.cssText =
      'position: fixed; bottom: 120px; right: 21px; width: 5.4rem; height: 5.4rem; padding: 0; border: 0; border-radius: 50%; background-color: #FFF; box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%); cursor: pointer; z-index: 200; transition: transform 0.2s ease-in-out; left: unset;';
    const icon = document.createElement('div');
    icon.style.cssText =
      'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; z-index: 20;';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = openIcon;
    button.appendChild(icon);
    document.body.appendChild(button);
    button.addEventListener('click', function () {
      let chatWindow = document.getElementById('dify-chatbot-bubble-window');
      if (chatWindow) {
        if (chatWindow.style.display === 'none') {
          chatWindow.style.display = 'block';
          icon.innerHTML = closeIcon;
          button.setAttribute('aria-expanded', 'true');
          button.setAttribute('aria-label', window.theme.liveChat.close_label || 'Close live chat');
          requestAnimationFrame(() => chatWindow.focus());
        } else {
          chatWindow.style.display = 'none';
          icon.innerHTML = openIcon;
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', window.theme.liveChat.open_label || 'Open live chat');
          button.focus();
        }
        return;
      }

      chatWindow = document.createElement('iframe');
      chatWindow.allow = 'fullscreen;microphone';
      chatWindow.title = 'Live chat';
      chatWindow.id = 'dify-chatbot-bubble-window';
      chatWindow.src = chatUrl;
      chatWindow.tabIndex = 0;
      chatWindow.style.cssText = `border: none; position: fixed; flex-direction: column; justify-content: space-between; box-shadow: rgba(150, 150, 150, 0.2) 0px 10px 30px 0px, rgba(150, 150, 150, 0.2) 0px 0px 0px 1px; bottom: 20px; right: 85px; width:${chatWidth}; min-width: ${minWidth}; height: calc(100vh - ${heightOffset});max-width:639px;border-radius: 0.75rem; display: flex; z-index: 99999; overflow: hidden; left: unset; background-color: #F3F4F6;`;
      chatWindow.addEventListener('load', () => chatWindow.focus(), { once: true });
      document.body.appendChild(chatWindow);
      icon.innerHTML = closeIcon;
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', window.theme.liveChat.close_label || 'Close live chat');
    });
  }
}
embedChatbot();

function chatClick() {
  document.addEventListener('click', function (event) {
    const chatTrigger = event.target.closest('#help-chat, [data-help-chat]');
    if (!chatTrigger) {
      return;
    }

    event.preventDefault();

    const chatBtn = document.querySelector('#dify-chatbot-bubble-button');
    if (chatBtn) {
      chatBtn.click();
    }
  });
}

chatClick();

function ceo() {
  const ceoDom = document.querySelector('.section-aqara-ceo');
  if (!ceoDom) {
    return;
  }
  const aSection = document.querySelector('.aqara-ceo-a-section');
  const bSection = document.querySelector('.aqara-ceo-b-section');

  let current = 0;

  let canToggleDown = true;
  let canToggleUp = false;

  let inSide = false;

  aSection.classList.add('sectionShow');

  function toggleShow(params) {
    if (params === 'down') {
      aSection.classList.remove('sectionShow');
      bSection.classList.add('sectionShow');
    } else {
      aSection.classList.add('sectionShow');
      bSection.classList.remove('sectionShow');
      canToggleDown = true;
    }
  }

  // 禁止滚动
  function preventDefault(e) {
    e.preventDefault();
  }

  function disableScroll() {
    document.addEventListener('wheel', preventDefault, { passive: false });
    document.addEventListener('touchmove', preventDefault, {
      passive: false,
    });
  }

  // 允许滚动
  function enableScroll() {
    document.removeEventListener('wheel', preventDefault);
    document.removeEventListener('touchmove', preventDefault);
  }

  document.addEventListener('scroll', (e) => {
    if (window.scrollY <= 0) {
      canToggleUp = true;
    }
  });

  ceoDom.addEventListener('mouseleave', () => {
    inSide = false;
  });

  ceoDom.addEventListener('wheel', (event) => {
    // 获取滚动容器相对于视口的位置
    const rect = ceoDom.getBoundingClientRect();

    // 获取鼠标相对于滚动容器的坐标
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    // 判断鼠标是否在滚动容器内
    const isInside =
      mouseX >= 0 &&
      mouseX <= ceoDom.offsetWidth &&
      mouseY >= 0 &&
      mouseY <= ceoDom.offsetHeight;

    if (isInside) {
      inSide = true;
      if (event.deltaY > 0 && canToggleDown) {
        disableScroll();
        canToggleDown = false;
        toggleShow('down');
        setTimeout(() => {
          enableScroll();
        }, 1000);
      }
      if (event.deltaY < 0 && canToggleUp) {
        disableScroll();
        canToggleUp = false;
        toggleShow('up');
        setTimeout(() => {
          enableScroll();
        }, 1500);
      }
    } else {
      inSide = false;
    }
  });
}

function timeline() {
  if (!document.querySelector('.section-timeline')) {
    return;
  }

  const timelineYearWrapper = document.querySelectorAll(
    '.timeline-year-wrapper'
  );

  // 获取屏幕宽度
  const screenWidth = document.documentElement.clientWidth;

  // 获取.timeline-line-dot-wrapper
  const timelineDotWrapper = document.querySelector(
    '.timeline-line-dot-wrapper'
  );

  // 获取.timeline-line-line
  const timelineLine = document.querySelector('.timeline-line-line');

  // 获取content-wrapper-out
  const contentWrapperOut = document.querySelector('.content-wrapper-out');
  const contentItems = document.querySelectorAll('.content-wrapper-inner');

  // 个数
  const count = timelineYearWrapper.length;

  // 获取年份的宽度
  const yearWidth = timelineYearWrapper[0].clientWidth;

  // 初始间距
  const initMove = screenWidth / 2 - yearWidth / 2;

  // 间距
  let gap;
  if (screenWidth > 680) {
    gap = 187;
  } else {
    gap = 20;
  }

  // 每个的间距
  const moveGap = gap + yearWidth;

  // 坐标
  let current = 0;

  // 修改timelineLine的宽度
  timelineLine.style.width = `${(yearWidth + gap) * (count - 1)}px`;
  timelineLine.style.left = `${yearWidth / 2}px`;

  // 修改timelineDotWrapper初始位置
  timelineDotWrapper.style.transform = `translateX(${initMove}px)`;

  function moveTo(index) {
    const now = initMove - index * (yearWidth + gap);
    timelineDotWrapper.style.transform = `translateX(${now}px)`;
    contentWrapperOut.style.transform = `translateX(-${
      index * screenWidth
    }px)`;
    contentWrapperOut.style.transitionDuration = '0.5s';
    btnStatus(index);
  }

  // 获取.text-next-btn
  const textNextBtn = document.querySelector('.text-next-btn');

  // 获取.text-prev-btn
  const textPrevBtn = document.querySelector('.text-prev-btn');

  timelineYearWrapper.forEach((item, index) => {
    if (index === 0) {
      item.classList.add('checked');
    }
  });

  // 判断按钮的禁用状态
  function btnStatus(index) {
    textPrevBtn.disabled = index <= 0;
    textNextBtn.disabled = index >= count - 1;
  }

  btnStatus(0);

  function changeClass(index) {
    timelineYearWrapper.forEach((item) => {
      item.classList.remove('checked');
      item.removeAttribute('aria-current');
    });

    timelineYearWrapper[index].classList.add('checked');
    timelineYearWrapper[index].setAttribute('aria-current', 'step');
    contentItems.forEach((item, itemIndex) => {
      item.setAttribute('aria-hidden', itemIndex === index ? 'false' : 'true');
    });
  }

  textNextBtn.addEventListener('click', () => {
    if (current >= count - 1) {
      return;
    }
    changeClass(current + 1);
    moveTo(current + 1);
    current++;
  });

  textPrevBtn.addEventListener('click', () => {
    if (current <= 0) {
      return;
    }
    changeClass(current - 1);
    moveTo(current - 1);
    current--;
  });

  let isDragging = false;
  let offsetX;
  let now;
  let over;

  function dragOver(params) {
    if (params > initMove) {
      moveTo(0);
      changeClass(0);
      current = 0;
    } else {
      // 判断最近的节点
      let realMove = Math.round((initMove - params) / moveGap);
      realMove = Math.min(realMove, count - 1);
      moveTo(realMove);
      changeClass(realMove);
      current = realMove;
    }
  }

  // 鼠标拖动事件
  timelineDotWrapper.addEventListener('mousedown', (e) => {
    isDragging = true;
    timelineDotWrapper.classList.add('draging');
    // 获取当前鼠标位置
    offsetX = e.clientX;
    now = parseInt(
      timelineDotWrapper.style.transform
        .split('(')[1]
        .split(')')[0]
        .split(',')[0]
    );
    over = now;
  });

  timelineDotWrapper.addEventListener('mousemove', (e) => {
    if (isDragging) {
      over = now + e.clientX - offsetX;
      timelineDotWrapper.style.transform = `translateX(${over}px)`;
    }
  });

  timelineDotWrapper.addEventListener('mouseup', () => {
    timelineDotWrapper.classList.remove('draging');
    dragOver(over);
    isDragging = false;
    timelineDotWrapper.style.cursor = 'grab';
  });
}

function industry() {
  let flag = true;
  const industryDom = document.querySelector('.section-industry');
  if (!industryDom) {
    return;
  }
  // 获取所有的industry-num
  const industryNum = document.querySelectorAll('.industry-num');

  // industryNum.forEach((item) => {
  //   item.innerHTML = 0;
  // });
  // 给滚动事件添加节流
  function throttle(fn, delay) {
    let last = 0;
    return function () {
      const now = Date.now();
      if (now - last > delay) {
        fn();
        last = now;
      }
    };
  }

  function numAdd() {
    if (!flag) {
      return;
    }
    flag = false;
    industryNum.forEach((item) => {
      const targetNum = item.innerHTML;
      // 总时间2000毫秒
      let nums = 0;
      let speed = 1;
      if (Number(targetNum) >= 2) {
        speed = 2;
      }
      if (Number(targetNum) >= 1000) {
        speed = 5;
      }
      const st = setInterval(() => {
        if (nums < targetNum) {
          item.innerHTML = Math.min(nums + speed, targetNum);
          nums += speed;
        } else {
          item.innerHTML = targetNum;
          clearInterval(st);
        }
      }, (2000 / targetNum) * speed);
    });
  }

  window.addEventListener(
    'scroll',
    throttle(function () {
      //  判断targetDom是否滚动到窗口顶部
      if (window.scrollY >= industryDom.offsetTop - 300) {
        numAdd();
      }
    }, 200)
  );
}

function brandStory() {
  ceo();
  timeline();
  industry();
}

brandStory()
